export const FeatureList = [
    { value: "has_dashboard", label: "Dashboard" },
    { value: "has_orders", label: "Orders" },
    { value: "has_kds_station", label: "KDS Station" },
    { value: "has_expo", label: "Expo" },
    { value: "has_menu", label: "Menu" },
    { value: "has_pos", label: "POS" },
    { value: "has_delivery", label: "Delivery" },
    { value: "has_business", label: "Business" }
];